/*
  We want to be able to quickly review the tasks here.
  - We don't care about done tasks.
  - We want to be able to quickly edit tasks status, move it, mark done etc.
  - We want to have different modes:
   - Review all tasks in todo and in progress - first MVP
   - Catch up on tasks in progress only - comes later.
   - Catch up on tasks that are not reviewed in 3 days? - comes later.
   - AI suggested tasks to review - comes later.
 */

import { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
  Text,
  HStack,
  Select,
  Divider,
  Progress
} from "@chakra-ui/react";

import Const from '../Constants';

import TaskDetails from '../Components/TaskDetails';
import { useTasksStore } from '../Stores/TasksStore';

const TaskStatusDropdown = ({ currentTask, onChange }) => {
  return (
    <Select
      size={Const.SM}
      color={Const.White}
      borderRadius={Const.MD}
      value={currentTask ? currentTask.status : ''}
      onChange={(e) => onChange?.(e.target.value)}
    >
      <option value={Const.sTodo}>{Const.sTodo}</option>
      <option value={Const.sInProgress}>{Const.sInProgress}</option>
    </Select>
  )
};

const CatchUpModal = ({ auth, isOpen, onClose, setAppMode }) => {
  const flatTasks = useTasksStore((state) => state.flatTasks);

  const handleUpdateTask_ = useTasksStore((state) => state.handleUpdateTask_);

  const [currentIndex, setCurrentIndex] = useState(0);

  const changeTaskStatus = useTasksStore((state) => state.changeTaskStatus);

  useEffect(() => {
    if (isOpen && auth) {
      setCurrentIndex(0);
    }
  }, [isOpen, auth]);

  const handleNext = () => {
    if (currentIndex !== flatTasks.length - 1) {
      setCurrentIndex((i) => i + 1);
    } else {
      setCurrentIndex(0);
      onClose();
    }
  };

  const handleTaskStatusChange = (newStatus) => {
    const taskId = flatTasks[currentIndex]?.id;
    if (!taskId) return;
    
    const oldStatus = flatTasks[currentIndex]?.status;
    changeTaskStatus(auth, taskId, oldStatus, newStatus);
  };

  const handleMarkDone = () => {
    // Mark the task done - note we are not updating the local state here, as we skipping to the next task anyway.
    // Note that we also update the status of the task to move it to the done section.
    handleUpdateTask_(auth, flatTasks[currentIndex].id, null, null, true, Const.sDoneUp);

    handleNext();
  };

  const handleSkip = () => {
    handleNext();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent rounded={Const.MD} backgroundColor={Const.Gray36}>
        <ModalHeader paddingBottom={1}>
        <VStack align={'center'} spacing={1} flex={1} mr={4}>
            <Text fontSize={Const.SM} color={Const.White} fontWeight={Const.Bold}>
              { `Catch up - ${flatTasks.length - currentIndex} Left` }
            </Text>
          </VStack>

          <Progress
            value={((currentIndex + 1) / flatTasks.length) * 100}
            height={'2px'}
            colorScheme={'green'}
            borderRadius={Const.MD}
            marginTop={4}
          />

        </ModalHeader>
        <ModalBody paddingTop={0}>
          
          <TaskDetails
              auth={auth}
              mode={Const.sCatchUpModal}
              currentTask={flatTasks[currentIndex]}
              setAppMode={(m) => { onClose(); setAppMode?.(m); }}
          />
          <Divider my={4} borderColor={Const.Gray100} />
        </ModalBody>

        <ModalFooter justifyContent="space-between" paddingTop={0}>
          <TaskStatusDropdown
            currentTask={flatTasks[currentIndex]}
            onChange={(newStatus) => {
              handleTaskStatusChange(newStatus);
            }}
          />

          <HStack>
            <Button
              onClick={handleMarkDone}
              colorScheme={'green'}
              size={Const.SM}
              marginLeft={24}
            >
              Mark Done
            </Button>
            <Button
              variant={'ghost'}
              size={Const.SM}
              color={Const.Gray165}
              _hover={{ background: Const.Gray180, color: Const.Gray31 }}
              onClick={handleSkip}
            >
              Skip
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CatchUpModal;
